export const localizeListOfNumbers = (numbers: number[], locale: string) => {
  const formatter = new Intl.ListFormat(locale, {
    style: 'long',
    type: 'disjunction',
  })

  return formatter.format(numbers.map(String))
}
